import { PublicChannelVideos } from '@wix/wix-vod-api-site-based/dist/src/public/services/channel-videos/channel-videos';
import { toError } from '../../parsers/to-error';
import { parseVideoItem } from '../../parsers/video-item';
export class PublicChannelVideosService {
    constructor(httpClient, baseUrl) {
        this.publicChannelVideos = new PublicChannelVideos(httpClient, baseUrl);
    }
    parseListChannelResponse(response, sort) {
        return Object.assign(Object.assign({}, response), { data: _.map(response.data.items, parseVideoItem), sort, paging: {
                size: response.data.items.length,
                cursor: response.data.cursor,
            } });
    }
    parseChannelVideoResponse(response) {
        return Object.assign(Object.assign({}, response), { data: parseVideoItem(response.data) });
    }
    async listChannelVideos({ channelId, query, tag, category, mediaType, sort, paging, hydratedChannelVideos, templateMetaSiteId, }) {
        try {
            const response = hydratedChannelVideos ||
                (await this.publicChannelVideos.getList({
                    channelId,
                    query,
                    tag,
                    category,
                    mediaType,
                    sort,
                    paging,
                    templateMetaSiteId,
                }));
            return this.parseListChannelResponse(response, sort);
        }
        catch (error) {
            return toError(error);
        }
    }
    async getChannelVideoById(channelId, videoId, { hydratedVideo, templateMetaSiteId, } = {}) {
        try {
            const response = hydratedVideo ||
                (await this.publicChannelVideos.getChannelVideoById(channelId, videoId, {
                    params: {
                        metaSiteId: templateMetaSiteId,
                    },
                }));
            return this.parseChannelVideoResponse(response);
        }
        catch (error) {
            return toError(error);
        }
    }
}
//# sourceMappingURL=channel-videos.js.map